@for (item of children; track trackByFn($index, item)) {
    <ms-tree-item
        [item]="item"
        [hideHeader]="hideHeader"
        (toggle)="onToggle($event)"
        (toggleMarkets)="onToggleMarkets($event)"
        (selectEvent)="onSelectEvent($event)" />
}
